import type { CharacterId, HudSnapshot } from "../game/GameBus";
import type { LevelNumber } from "../game/levels";
import { getAccessoryForCharacter, type AccessoryId } from "../game/wardrobe";
import { CharacterPreview } from "./CharacterPreview";
import { CrownIcon, GemIcon, ReplayIcon, StarIcon } from "./Icons";

interface ResultScreenProps {
  character: CharacterId;
  hud: HudSnapshot;
  level: LevelNumber;
  totalLevels: number;
  levelName: string;
  gemTotal: number;
  wisdomStarTotal: number;
  equippedAccessoryId: AccessoryId | null;
  newlyUnlockedAccessoryId: AccessoryId | null;
  onReplay: () => void;
  onOpenWardrobe: () => void;
}

export function ResultScreen({
  character,
  hud,
  level,
  totalLevels,
  levelName,
  gemTotal,
  wisdomStarTotal,
  equippedAccessoryId,
  newlyUnlockedAccessoryId,
  onReplay,
  onOpenWardrobe,
}: ResultScreenProps) {
  const reward = getAccessoryForCharacter(character, newlyUnlockedAccessoryId);

  return (
    <main className={`result-screen ${character}`}>
      <div className="result-backdrop" />
      <section className="storybook-panel result-panel">
        <h1>כל הכבוד!</h1>
        <h2>שלב {level} הושלם</h2>
        <p className="result-level-name">{levelName}</p>
        <div className="reward-band">
          {Array.from({ length: gemTotal }, (_, index) => <GemIcon key={index} className={index < hud.gems ? "earned" : "unearned"} />)}
        </div>
        <div className="reward-band">
          {Array.from({ length: wisdomStarTotal }, (_, index) => <StarIcon key={index} className={index < hud.wisdomStars ? "earned" : "unearned"} />)}
        </div>
        <div className={`sticker-reward ${reward ? "has-new-reward" : ""}`}>
          <CrownIcon />
          <span>{reward ? `פריט חדש: ${reward.displayName}` : "אפשר לבחור לבוש במלתחה"}</span>
        </div>
        <div className="result-actions">
          <button className="secondary-button" onClick={onReplay}><ReplayIcon />שוב את שלב {level}</button>
          <button className="primary-button" autoFocus onClick={onOpenWardrobe}>
            {level >= totalLevels ? "לבחירת לבוש אחרון" : "לבחירת לבוש"}
          </button>
        </div>
      </section>
      <CharacterPreview
        character={character}
        accessoryId={equippedAccessoryId}
        alt={character === "dragon" ? "הדרקון חוגג" : "חד־הקרן חוגג"}
        className={`result-character ${character}`}
      />
    </main>
  );
}
